import React from 'react';
import { Sliders } from 'lucide-react';
import '../styles/MobileFiltersButton.css';

const MobileFiltersButton = ({ filtersOpen, setFiltersOpen, activeFiltersCount, isMobile }) => {
  if (!isMobile) return null;

  return (
    <button
      onClick={() => setFiltersOpen(!filtersOpen)}
      className={`mobile-filters-button ${filtersOpen ? 'active' : ''}`}
    >
      <Sliders size={16} className="mobile-filters-icon" />
      {activeFiltersCount > 0 && (
        <div className="mobile-filters-badge">{activeFiltersCount}</div>
      )}
    </button>
  );
};

export default MobileFiltersButton;